<template>
  <Modal :show="show" @close="closeModal" max-width="2xl">
    <div class="p-1">
      <SupportForm @submitted="onSubmitted" @close="closeModal" />
    </div>
  </Modal>
</template>

<script setup>
import Modal from '@/Components/Modal.vue';
import SupportForm from '@/Components/SupportForm.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'submitted']);

const closeModal = () => {
  emit('close');
};

const onSubmitted = (data) => {
  emit('submitted', data);
};
</script>
